<template>
  <div class="z-main z-login">
    <div class="z-header">
      <div>
        <router-link to="/index/keyOrder"><img src="../../assets/sysbars/left.png" /></router-link>
      </div>
      <div>新增</div>
      <div></div>
    </div>

    <div class="z-body">
      <form autocomplete="on">
        <div class="z-form-item" style="background:none;">
          <div class="z-form-label">
            <span class="dark-color">类型</span>
          </div>
          <div class="z-input-block">

            <v-radio-group v-model="type" :mandatory="false">
              <div class="z-flex">
                <v-radio label="会员代号" value="name" color="#000"></v-radio>
                <v-radio label="交易账户" value="trade" color="#000"></v-radio>
              </div>
            </v-radio-group>

          </div>
        </div>

        <div class="z-form-item my-input-bg">
          <div class="z-form-label">
            账号
          </div>
          <div class="z-input-block">
            <input v-model="account" placeholder="用户名">
          </div>
        </div>

        <div class="z-form-item my-input-bg">
          <div class="z-form-label">
            密码
          </div>
          <div class="z-input-block">
            <input type="password" v-model="password" placeholder="登陆密码">
          </div>
          <div>
          </div>
        </div>

        <div class="z-form-item" style="background:none;">
          <div @click="onAdd" class="z-btn-long" style="background: #3E3E3E;">新增</div>
        </div>

      </form>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'addSubAccount',
    data() {
      return {
        type: 'name', //name  trade
        account: "",
        password: "",

      }
    },
    created() {

    },
    methods: {
      onAdd() {
        let params = {
          type: this.type,
          username: this.account,
          pwd: this.password
        }
        this.post('api/user_bind/add', params).then((rs) => {
          if (rs.code == 0) {
            setTimeout(() => {
              this.$router.push('/index/keyOrder')
            }, 1000)
          }
          this.$store.commit('layer', rs.msg)
        })
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .theme--dark.v-icon {
    color: #000000 !important;
  }

  .v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {
    margin-bottom: 0px;
  }

  .z-account-list {
    z-index: 99;
    background-color: #FFFFFF;
    color: #666666;
    width: 100%;
    position: absolute;
    left: 0;
    letter-spacing: 2px;
    text-align: center;
  }

  .z-account-list ul {
    width: 100%;
    height: auto;
    padding: 0px;
    height: auto;
    max-height: 180px;
    overflow: scroll;
  }

  .z-account-list ul li {
    padding: 0 24px;
    width: 100%;
    height: 36px;
    line-height: 36px;
    font-size: 14px;
    list-style-type: none;
    border-bottom: 1px solid #cccccc;
  }

  .z-login .v-input--radio-group .v-radio,
  .z-login .v-input__slot {
    margin-bottom: 0px;
  }

  .my-input-bg {
    background-color: #ddd;
  }
</style>



// WEBPACK FOOTER //
// src/pages/index/newAccount.vue